import { jsx as _jsx } from "react/jsx-runtime";
import HyperDX from '@hyperdx/browser';
import { isNil } from 'lodash';
import { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { compose } from 'redux';
import { Spinner, APPLICANTS_URL, CREDIT_PORTAL_URL, QUERY_KEY, useIovation, makeQueryPath, } from 'shared';
import { useGetConsumerApplicationsV1PrequalificationsNewQuery, usePatchConsumerApplicationsV1CreditApplicationsApplicationIdMutation, usePostConsumerApplicationsV1PrequalificationsApplicationIdNextLenderMutation, } from 'consumer-applications-v1-api';
import { determinePrequalificationResponse, flashSubmitFailure } from 'utils';
import * as creditAppActions from '../../credit_application/actions';
import { setApplicationEnvironment as setApplicationEnvironmentCreditApplication } from '../../credit_application/actions';
import * as actions from '../actions';
import { setApplicationEnvironment as setApplicationEnvironmentApplicant } from '../actions';
import { selectors } from '../reducer';
import ApplicantShow from './ApplicantShow';
function ContinuedCreditApplication({ clearApplicant, creditApplication, practice, setPrequalification, setPersonalInfo, setPractice, setLenderReferenceId, clearApplicationEnvironment, applicationEnvironment, }) {
    const { search } = useLocation();
    const dispatch = useDispatch();
    const history = useHistory();
    const [getBlackboxData] = useIovation();
    const { locationId } = practice || {};
    const [prequalifyWithNextLender] = usePostConsumerApplicationsV1PrequalificationsApplicationIdNextLenderMutation();
    const { data: newCreditApplication, isFetching: isFetchingCreditApplication, } = useGetConsumerApplicationsV1PrequalificationsNewQuery({ locationId });
    const [patchApplicant] = usePatchConsumerApplicationsV1CreditApplicationsApplicationIdMutation();
    const { applicationId } = creditApplication;
    const handleSubmit = (formValues) => {
        HyperDX.setGlobalAttributes({
            locationId: practice.locationId.toString() || '',
            creditApplicationId: creditApplication.applicationId?.toString() || '',
            lastName: formValues.lastName,
            firstName: formValues.firstName,
            email: formValues.email,
            phone: formValues.primaryPhone,
            form: 'cont-cred-app',
        });
        return patchApplicant({
            applicationId: applicationId ? applicationId : '',
            patchConsumerApplicationsV1CreditApplicationsApplicationId: formValues,
        }).then(() => {
            return prequalifyWithNextLender({
                applicationId: applicationId ? applicationId : '',
                postConsumerApplicationsV1PrequalificationsApplicationIdNextLender: {
                    iovationBlackBox: getBlackboxData().blackbox,
                },
            }).then((response) => {
                if ('data' in response) {
                    setPractice(practice);
                    setPersonalInfo(formValues);
                    setPrequalification(response.data);
                    setLenderReferenceId(response.data.lenderRequestReferenceId ?? '');
                    return response.data;
                }
            });
        });
    };
    const handleSubmitSuccess = (response) => {
        const nextStep = determinePrequalificationResponse(response, 'no-modal');
        history.push(nextStep);
        return;
    };
    const handleSubmitFailure = (errors, dispatch, submitError) => {
        const apiErrorCode = submitError?.meta?.error?.response?.errorCode;
        if (apiErrorCode === 'new_application_required') {
            history.push(makeQueryPath(CREDIT_PORTAL_URL, { [QUERY_KEY.ERROR]: apiErrorCode }));
        }
        else {
            flashSubmitFailure(errors, dispatch, submitError);
        }
    };
    useEffect(() => {
        if (newCreditApplication) {
            dispatch(setApplicationEnvironmentApplicant(newCreditApplication));
            dispatch(setApplicationEnvironmentCreditApplication(newCreditApplication));
        }
    }, [newCreditApplication]);
    useEffect(() => {
        return () => {
            clearApplicant();
            clearApplicationEnvironment();
        };
    }, []);
    if ((isNil(creditApplication) && !isFetchingCreditApplication) || !practice) {
        return (_jsx(Redirect, { to: {
                pathname: APPLICANTS_URL,
                search: search,
            } }));
    }
    if (!applicationEnvironment)
        return _jsx(Spinner, { centerPage: true });
    return (_jsx(ApplicantShow, { practice: practice, handleSubmit: handleSubmit, handleSubmitSuccess: handleSubmitSuccess, handleSubmitFailure: handleSubmitFailure, applicationEnvironment: applicationEnvironment }));
}
function mapStateToProps(state) {
    return {
        creditApplication: selectors.creditApplication(state),
        practice: selectors.practice(state),
        applicationEnvironment: selectors.applicationEnvironment(state),
    };
}
const mapDispatchToProps = {
    clearApplicant: actions.clearApplicant,
    setPrequalification: creditAppActions.setPrequalification,
    setPersonalInfo: creditAppActions.setPersonalInfo,
    setPractice: creditAppActions.setPractice,
    setLenderReferenceId: creditAppActions.setLenderReferenceId,
    clearApplicationEnvironment: actions.clearApplicationEnvironment,
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(ContinuedCreditApplication);
